import { Injectable } from '@angular/core';
import { MessagingApi } from 'src/app/api/messaging/messaging.api';
import { NotifyOfCommentDTO } from 'src/app/model/communication/notify-of-comment-dto.model';
import { NudgeDTO } from 'src/app/model/communication/nudge-dto.model';
import { NudgeObservationDTO } from 'src/app/model/communication/nudge-observation-dto.model';

@Injectable()
export class MessagingService {

    constructor(private messagingApi: MessagingApi) { }

    getMessage = (messageRecipientId: string) => this.messagingApi.getMessage(messageRecipientId);

    messages = (offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, start?:string, end?:string) => this.messagingApi.messages(offset, limit, orderBy, ascending, searchBy, start, end);

    nudge = (nudge: NudgeDTO) => this.messagingApi.nudge(nudge);

    nudgeObservation = (nudgeObservation: NudgeObservationDTO) => this.messagingApi.nudgeObservation(nudgeObservation);
    
    notifyOfComment = (notifyOfCommentDTO: NotifyOfCommentDTO) => this.messagingApi.notifyOfComment(notifyOfCommentDTO);
}
